import { render } from "./InputSelect.vue?vue&type=template&id=02889870&scoped=true"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=02889870&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02889870"]])

export default __exports__